"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constants = require("../constants");
// checkbox, radio group, switch

const styleOverrides = {
  root: {
    alignItems: 'start',
    '&.Mui-required div': {
      paddingTop: 11
    }
  },
  label: {
    paddingTop: 11,
    color: _constants.colors.text.primary
  }
};
const defaultProps = {
  color: 'inputElements'
};
var _default = exports.default = {
  styleOverrides,
  defaultProps
};
//# sourceMappingURL=MuiFormControlLabel.js.map